import React, { useState, useEffect } from 'react';
import axiosInstance from '../axiosConfig';
import Header from '../Components/Header';
import Sidebar from '../Components/Sidebar';
import '../styles.css';

const LeaveTransaction = () => {
  const [userData, setUserData] = useState(null);
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('all');

  const currentUserId = localStorage.getItem('id');
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [isIdCardPopupVisible, setIsIdCardPopupVisible] = useState(false);

  useEffect(() => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 520) {
      setIsSidebarVisible(false);
    } else {
      setIsSidebarVisible(true);
    }
  }, []);

  const handleToggleClick = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  useEffect(() => {
    if (currentUserId) {
      axiosInstance.get(`/user/${currentUserId}/`)
        .then((response) => setUserData(response.data))
        .catch((error) => console.error('Error fetching user data:', error));
    }
  }, [currentUserId]);

  useEffect(() => {
    fetchLeaveRequests();
  }, [filterStatus]);

  const fetchLeaveRequests = () => {
    let url = '/leave/search/';
    if (filterStatus !== 'all') {
      url += `?status=${filterStatus}`;
    }

    setLoading(true);
    axiosInstance.get(url)
      .then((response) => {
        setLeaveRequests(response.data.leave_request);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching leave requests:', error);
        setLoading(false);
      });
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  const profilePhotoUrl = userData?.profile_photo?.startsWith('http://')
    ? userData?.profile_photo.replace('http://', 'https://')
    : userData?.profile_photo;

  const menuItems = [
    { icon: '🏠', label: 'Dashboard', path: '/user-dashboard' },
    { icon: '👤', label: 'My Profile', path: `/user-profile/${userData?.id}` },
    { icon: '📅', label: 'Attendance', path: `/leave-attendance/${userData?.id}` },
    { icon: '📋', label: 'Leave Management', path: `/leave-management/${userData?.id}` },
    { icon: '✏️', label: 'Create Leave Request', path: `/leave-request/${userData?.id}` },
    { icon: '💰', label: 'Leave Balance', path: '/leave-balance' },
    { icon: '📊', label: 'Leave Transactions', path: '/leave-transaction/' },
    // { icon: '📅', label: 'Calendar', path: '/calendar' },
    // { icon: '&#128178;', label: 'Payroll', path: 'https://hrms.teamhalt.com/', active: false },
    { icon: '🆔', label: 'ID Card', action: () => setIsIdCardPopupVisible(true) },
  ];

  const getStatusBadgeClass = (status) => {
    const statusLower = status?.toLowerCase();
    return `status-badge ${statusLower}`;
  };

  return (
    <div className={`dashboard-wrapper ${isSidebarVisible ? 'sidebar-open' : 'sidebar-closed'}`}>
      <Header
        onToggleClick={handleToggleClick}
        isSidebarVisible={isSidebarVisible}
      />

      <Sidebar
        isSidebarVisible={isSidebarVisible}
        currentUser={userData}
        menuItems={menuItems}
        handleLogout={handleLogout}
      />

      <div className="dashboard-main-content">
        <div className="leave-transaction-container">
          <div className="leave-transaction-header">
            <h1>Leave Transactions</h1>
            <p>View and manage your leave requests</p>
          </div>

          <div className="leave-transaction-filter">
            <label>Filter by Status:</label>
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="filter-select"
            >
              <option value="all">All Requests</option>
              <option value="approved">Approved</option>
              <option value="pending">Pending</option>
              <option value="rejected">Rejected</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>

          {loading ? (
            <div className="leave-transaction-loading">
              <div className="loading-spinner"></div>
              <p>Loading leave transactions...</p>
            </div>
          ) : (
            <div className="leave-transaction-card">
              <div className="leave-transaction-table-wrapper">
                {leaveRequests.length > 0 ? (
                  <table className="leave-transaction-table">
                    <thead>
                      <tr>
                        <th>Leave Type</th>
                        <th>Applied On</th>
                        <th>Dates</th>
                        <th>Days</th>
                        <th>In/Out</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {leaveRequests.map((leaveRequest) => (
                        <tr key={leaveRequest.id}>
                          <td>{leaveRequest.leave_type}</td>
                          <td>{new Date(leaveRequest.created_at).toLocaleDateString()}</td>
                          <td>
                            {leaveRequest.start_date} to {leaveRequest.end_date}
                          </td>
                          <td>{leaveRequest.days}</td>
                          <td>{leaveRequest.in_out || 'N/A'}</td>
                          <td>
                            <span className={getStatusBadgeClass(leaveRequest.status)}>
                              {leaveRequest.status}
                            </span>
                          </td>
                          <td>
                            <a href={`/leave-details/${leaveRequest.id}`} className="action-link">
                              View
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-data">No leave requests found</div>
                )}
              </div>
            </div>
          )}
        </div>

        {isIdCardPopupVisible && (
          <div className="id-card-overlay" onClick={() => setIsIdCardPopupVisible(false)}>
            <div className="id-card-popup" onClick={(e) => e.stopPropagation()}>
              <button className="id-card-close" onClick={() => setIsIdCardPopupVisible(false)}>×</button>
              <div className="id-card-header">
                <img src="/Teamhalt.png" alt="Logo" className="id-card-logo" />
                <span>TEAMHALT PRIVATE LIMITED</span>
              </div>
              <div className="id-card-body">
                <div className="id-card-profile">
                  <img src={profilePhotoUrl || '/profile.jpg'} alt="Profile" className="id-card-photo" />
                  <div className="id-card-info">
                    <h4>{userData?.first_name} {userData?.last_name}</h4>
                    <p className="id-designation">{userData?.designation}</p>
                    <div className="id-dob">
                      <strong>DOB:</strong>
                      <span>{userData?.date_of_birth ? new Date(userData.date_of_birth).toLocaleDateString("en-GB").replace(/\//g, "-") : "N/A"}</span>
                    </div>
                  </div>
                </div>
                <hr className="id-card-divider" />
                <div className="id-card-details">
                  {[
                    { label: "Emp ID", value: userData?.employee_code },
                    { label: "Department", value: userData?.department },
                    { label: "ESIC No.", value: userData?.esic_no },
                    { label: "UAN No.", value: userData?.uan_no },
                    { label: "Gender", value: userData?.gender },
                    { label: "Contact No.", value: userData?.contact_number },
                  ].map((item, idx) => (
                    <div key={idx} className="detail-row">
                      <strong>{item.label}:</strong>
                      <span>{item.value || "N/A"}</span>
                    </div>
                  ))}
                </div>
                {typeof userData?.work_location_name === "string" && userData.work_location_name.toLowerCase() !== "noida" && (
                  <div className="id-card-duty">
                    <strong>On Contractual Duty Of:</strong>
                    <span>{userData?.duty_of || "N/A"}</span>
                  </div>
                )}
                <div className="id-card-footer">https://teamhalt.com/</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeaveTransaction;

